import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4b145c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-box" }
const _hoisted_2 = {
  key: 0,
  class: "form"
}
const _hoisted_3 = { class: "form-main" }
const _hoisted_4 = { class: "form-body" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "代理类型", -1))
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "代理信息", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createTextVNode(" 每行一条线路信息，支持以下格式： "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 格式1：ip:端口 账号 密码 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 格式2：ip|端口|账号|密码|到期日期 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 格式3：ip/端口/账号/密码 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 格式4：ip/端口/账号/密码/地区 ")
], -1))
const _hoisted_10 = { class: "form-btn-group" }
const _hoisted_11 = {
  key: 1,
  class: "form"
}
const _hoisted_12 = { class: "form-main" }
const _hoisted_13 = { class: "form-body" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { style: {"margin-bottom":"10px"} }
const _hoisted_16 = { class: "form-btn-group" }

import { computed, inject, reactive } from 'vue';
import { request } from '@/util/request';
import SelectRemote from '@/components/business/crud/common/SelectRemote.vue';
import SelectRemoteMulti from '@/components/business/crud/common/SelectRemoteMulti.vue';
import { WindowTool } from '@/components/common/window/WindowInterface';
import ProxyForm from '@/views/management/proxy/import/ProxyForm.vue';
import { message } from 'ant-design-vue';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import { ProxyItem } from '@/views/management/proxy/import/ProxyTypes';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportProxy',
  props: {
    onSubmit: { type: Function },
    selectTagGroup: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const windowTool = inject<WindowTool | false>(WindowTool, false);

const data = reactive({
  stage: 0,
  data: {
    content: '',
    hasError: false,
    values: [] as ProxyItem[],
  },
  type: 'socks5',
  group: null as any,
  tags: [] as any,
  checking: false,
  removeIndex: {} as Record<string, true>,
  result: {} as Record<string, { outIp: string; area: string }>, // 检测结果
});

const resultTableData = computed(() => {
  return data.data.values
    .filter((i) => !data.removeIndex[i.index])
    .map((item) => {
      const result = getItemResult(item);
      return {
        index: item.index,
        raw: item.raw,
        outIp: result?.outIp || '',
        area: result?.area || '',
      };
    });
});

function getItemResult(item: ProxyItem) {
  const key = [
    data.type,
    item.host,
    item.port,
    item.username,
    item.password,
  ].join('|');
  return data.result[key];
}

function setItemResult(
  item: ProxyItem,
  result: { outIp: string; area: string }
) {
  const key = [
    data.type,
    item.host,
    item.port,
    item.username,
    item.password,
  ].join('|');
  data.result[key] = result;
}

// 连接检测
async function check() {
  if (data.data.hasError) {
    message.error('请先处理导入信息中的错误');
    return;
  }
  if (data.data.values.length === 0) {
    message.error('请先添加有效的导入信息');
    return;
  }
  data.stage = 1;
  await checkFail();
}

async function recheck(item: ProxyItem) {
  const res = await request('management/proxy/checkProxyInfo', {
    type: data.type,
    data: [item],
  });
  if (res) {
    setItemResult(item, res[0]);
  }
}

async function checkFail() {
  data.checking = true;
  const fails = data.data.values.filter((item) => !getItemResult(item));
  const res = await request('management/proxy/checkProxyInfo', {
    type: data.type,
    data: fails,
  });
  if (res) {
    fails.forEach((item, i) => {
      setItemResult(item, res[i]);
    });
  }
  data.checking = false;
}

async function removeFail() {
  data.data.values
    .filter((item) => !getItemResult(item))
    .map((item) => {
      data.removeIndex[item.index] = true;
    });
}

async function submit() {
  if (data.data.values.length === 0) {
    if (windowTool) {
      windowTool.close(true);
    }
    return;
  }
  const proxies = data.data.values.map((i) => {
    const checkResult = getItemResult(i);
    return {
      type: data.type,
      group: data.group?.id,
      tags: {
        attach: data.tags.map((i: any) => i.id),
      },
      host: i.host,
      port: i.port,
      username: i.username,
      password: i.password,
      expiredTime: i.expiredTime,
      status: checkResult ? 'normal' : 'error',
      outIp: checkResult?.outIp || '',
      area: checkResult?.area || '',
    };
  })
  const res = await props.onSubmit(proxies);
  if (res) {
    if (windowTool) {
      windowTool.close(true);
    }
  }
}

function toStage0() {
  data.removeIndex = {};
  data.stage = 0;
}

const groupWidget = {
  name: 'selectRemote',
  multi: false,
  path: 'management/proxy_group/index',
  // 标签字段名,默认name
  labelFieldName: 'name',
  // 数据字段名，默认id
  valueFieldName: 'id',
  // 创建页面路径
  createPagePath: 'management/proxy_group/create',
  // 查看页面路径，会替换__value__为字段值
  viewPagePath: 'management/proxy_group/view?id=__value__',
};
const tagWidget = {
  name: 'selectRemote',
  multi: true,
  path: 'management/proxy_tag/index',
  // 标签字段名,默认name
  labelFieldName: 'name',
  // 数据字段名，默认id
  valueFieldName: 'id',
  // 创建页面路径
  createPagePath: 'management/proxy_tag/create',
  // 查看页面路径，会替换__value__为字段值
  viewPagePath: 'management/proxy_tag/view?id=__value__',
};

const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
  },
  {
    title: '代理信息',
    dataIndex: 'raw',
    key: 'raw',
  },
  {
    title: '出口IP',
    dataIndex: 'outIp',
    key: 'outIp',
  },
  {
    title: '归属地',
    dataIndex: 'area',
    key: 'area',
  },
  {
    title: '检测结果',
    dataIndex: 'result',
    key: 'result',
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (data.stage === 0)
      ? (_openBlock(), _createElementBlock("form", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: data.type,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((data.type) = $event)),
                  style: {"width":"300px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "http" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Http")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "socks5" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Socks5")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _createVNode(ProxyForm, {
                  modelValue: data.data,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.data) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(ScBtn, {
              type: "primary",
              handler: check,
              text: "连接检测"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (data.stage === 1)
      ? (_openBlock(), _createElementBlock("form", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("div", _hoisted_14, [
                _createVNode(_component_a_descriptions, {
                  layout: "vertical",
                  bordered: "",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_descriptions_item, { label: "分组" }, {
                      default: _withCtx(() => [
                        _createVNode(SelectRemote, {
                          style: {"width":"100%"},
                          title: "分组",
                          widget: groupWidget,
                          modelValue: data.group,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.group) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "标签" }, {
                      default: _withCtx(() => [
                        _createVNode(SelectRemoteMulti, {
                          style: {"width":"100%"},
                          title: "标签",
                          widget: tagWidget,
                          modelValue: data.tags,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.tags) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, _ctx.selectTagGroup]
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(ScBtn, {
                  handler: () => checkFail(),
                  text: "重新检测失败线路",
                  style: {"margin-right":"8px"}
                }, null, 8, ["handler"]),
                _createVNode(ScBtn, {
                  text: "移除失败线路",
                  handler: removeFail
                })
              ]),
              _createVNode(_component_a_table, {
                columns: columns,
                "data-source": resultTableData.value,
                pagination: false,
                loading: data.checking
              }, {
                bodyCell: _withCtx(({ column, record }) => [
                  (column.dataIndex === 'result')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (!data.checking)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (record.outIp)
                                ? (_openBlock(), _createBlock(_component_a_tag, {
                                    key: 0,
                                    color: "green"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 连接正常")
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createBlock(_component_a_tag, {
                                    key: 1,
                                    color: "red"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 连接失败")
                                    ]),
                                    _: 1
                                  }))
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(record[column.key]), 1)
                      ], 64))
                ]),
                _: 1
              }, 8, ["data-source", "loading"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(ScBtn, {
              type: "primary",
              handler: submit,
              text: data.data.values.length > 0 ? '导入' : '关闭',
              style: {"margin-right":"20px"}
            }, null, 8, ["text"]),
            _createVNode(ScBtn, {
              handler: toStage0,
              text: "上一步"
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})